<template>
  <main class="main" role="main">
    <div class="page">
      <div class="inner">
        <div class="lnb">
          <ul>
            <li><p class="home"></p></li>
            <li><p>소식 알림</p></li>
            <li><p>자료실</p></li>
          </ul>
        </div>
        <div class="page_ttl">
          <h1 class="h1">
            <span>자료실</span>
          </h1>
        </div>
        <news-view :item="item" :files="files" :boardType="this.params.boardType" :no="this.params.no" />
        <div class="page_btn">
          <button class="btn" @click="fnBack">목록으로</button>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import NewsView from '@/components/pages/news/view/index'

export default {
  name: 'news-data-view',
  components: { NewsView },
  description: '자료실 - 상세',
  data: function() {
    const query = this.$route.query
    return {
      params: {
        dataNo: Number(query.dataNo)
      },
      item: {},
      files: []
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData: async function() {
      // 홈페이지 유지보수 개발요청안 | 게시물다운로드 횟수 및 조회수 카운트 섹션 생성 (서남아이에스 임현아, 2024-07-02) 
      this.params.no = Number(this.$route.query.dataNo)
      this.params.boardType = 3

      const res = await this.$NewsSvc.getMapData(this.params)
      if (res.code === 1) {
        this.item = res.entity.data
        this.files = res.entity.files
      }
    },
    fnBack: function() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped></style>
